<script>
/**
 * input component with white background and no border
 * use for main card layout
 */
export default {
  props: {
    title: {
      type: String,
      require: false,
      default: '',
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="title"
      class="text-subtitle-1 text-start white--text font-weight-bold"
      >{{ this.$t(title) }}</div
    >
    <v-text-field
      v-bind="$attrs"
      solo
      flat
      color="black"
      dense
      background-color="white"
      class="base-input-flat-error-message"
      v-on="$listeners"
      @input="(v) => $emit('input', v)"
    />
  </div>
</template>

<style lang="sass" scoped>
.base-input-flat-error-message
  ::v-deep .v-messages
    font-size: $font-size-root
    font-weight: map-get($font-weights, 'bold')
</style>
